import React from 'react';

import instagram from './assets/icons/instagram_white.png';
import twitter from "./assets/icons/twitter_white.png"

import bbva from './assets/patrocinadores/bbva white.png';
import spisemisuaps from './assets/patrocinadores/spisemisuaps.png';
import gresearch from './assets/patrocinadores/gresearch.png';
import qualcomm from './assets/patrocinadores/qualcomm_logo_white.png';
import upc from './assets/patrocinadores/Logo_UPC_CFIS.png';

import "./css/footer.css";

export default function Footer() {
    const patrocinadores = [
        {nombre: "BBVA", logo: bbva, link: "https://www.bbva.es/personas.html", tipo: "DIAMANTE"},
        {nombre: "SPISE MISU ApS", logo: spisemisuaps, link: "https://spisemisu.com/", tipo: "DIAMANTE"},
        {nombre: "G Research", logo: gresearch, link: "https://www.gresearch.com/", tipo: "DIAMANTE"},
        {nombre: "Qualcomm", logo: qualcomm, link: "https://www.qualcomm.com/", tipo: "DIAMANTE"},
        {nombre: "UPC CFIS", logo: upc, link: "https://cfis.upc.edu/es", tipo: "Colaboración de Honor"}
    ]

    const redes = [
        {nombre:"instagram", logo: instagram, link:"https://www.instagram.com/oifem_es/"},
        {nombre: "X", logo: twitter, link: "https://x.com/OIFem_ES"}
    ]

    return (
        <div id="footer">
            <h2>Desde la OIFem agradecemos el apoyo de:</h2>

            <div id="patrocinadores">
                {patrocinadores.map((patrocinador, index) => (
                    <div className='patrocinador' key={index}>
                        <a className='footer-link' href={patrocinador.link} target="_blank" rel="noopener noreferrer">
                            <img src={patrocinador.logo} alt={patrocinador.nombre} />
                        </a>
                        <p>{patrocinador.tipo}</p>
                    </div>
                ))}
            </div>

            <h2>Síguenos en redes:</h2>
            <div id='redes'>
                
                {redes.map((red) => (
                    <a className='red-link' href={red.link} target="_blank" rel="noopener noreferrer">
                        <img src={red.logo} alt={red.nombre} />
                    </a>
                ))}
                
            </div>
        </div>
    );
}